import React from 'react'

import lastTouchChoices from '../misc/lastTouchChoices'
import {
  Tags,
  Tag,
} from '../../styles/tags'

const LastTouchChooser = () => (
  <Tags>
    {lastTouchChoices.map(opt => (
      <Tag key={opt.name}>
        <input
          id={'last-touch-'+opt.days}
          type="radio"
          name="lastTouch"
          value={opt.days}
        />
        <label htmlFor={'last-touch-'+opt.days}>{opt.name}</label>
      </Tag>
    ))}
  </Tags>
)

export default LastTouchChooser



// WEBPACK FOOTER //
// ./src/views/personNew/LastTouchRadios.js